export default "__VITE_ASSET__B02gxcOC__"